<template>
    <span>
        {{ $t('actions.index') }}:

        <a v-if="hasConditions" :href="conditionsHref">
            {{ $tc('criteria.count', related.conditions_count) }}
        </a>

        <template v-if="hasBoth">
            {{ $t('common.conjunction') }}
        </template>

        <a v-if="hasConsequences" :href="consequencesHref">
            {{ $tc('effects.count', related.consequences_count) }}
        </a>

        <template v-if="isEmpty">
            {{ $tc('actions.count', 0) }}
        </template>
    </span>
</template>

<script>
export default {
    name: 'ActionsFilterLink',

    props: {
        filterBy: {type: String, required: true},
        related: {type: Object, required: true},
    },

    computed: {
        hasConditions() {
            return this.related.conditions_count > 0;
        },

        hasConsequences() {
            return this.related.consequences_count > 0;
        },

        hasBoth() {
            return this.hasConditions && this.hasConsequences;
        },

        isEmpty() {
            return !this.hasConditions && !this.hasConsequences;
        },

        conditionsHref() {
            return this.$toRoute('actions.index', {
                [`filter_by[criteria][${this.filterBy}]`]: this.related.id,
            }).toString();
        },

        consequencesHref() {
            return this.$toRoute('actions.index', {
                [`filter_by[effects][${this.filterBy}]`]: this.related.id,
            }).toString();
        },
    },
};
</script>
